<template>
<div class="alumno">
    <vs-button :loading="loadingGuardar" :disabled="profesor.length <= 0" success @click="actualizarRegistrosBloque">
        <b> Guardar </b>
    </vs-button>
    <vs-table ref="tabla_asignacion_bloques"  class="unset-min-width left-footer-unset-radius left-header-unset-radius">
        <template #thead>
            <vs-tr>
                <vs-th width="25px">
                    <vs-checkbox
                        :indeterminate="Boolean(selectedInThePage.length)" v-model="allCheck"
                        @change="checkAllOnThisPage"
                    />
                </vs-th>
                <vs-th width="250px">
                    Alumno
                </vs-th>
                <vs-th>
                    Programa
                </vs-th>
                <vs-th>
                    Tipo
                </vs-th>
            </vs-tr>
        </template>
        <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in tablaData"
                :data="tr"
                :is-selected="(selectedRow && selectedRow.id) == (tr &&tr.id)"
            >
                <vs-td checkbox>
                    <vs-checkbox :val="tr" v-model="selectedRow" v-if="checkRegistroAcademico(tr)" />
                </vs-td>
                <vs-td>
                   <p class="mb-0"><strong> {{ tr.apellido_paterno ? tr.apellido_paterno : '' }} 
                    {{ tr.apellido_materno ? tr.apellido_materno  : '' }} 
                    {{ tr.nombres ? tr.nombres : '' }}</strong></p>
                    <p class="mb-0"><small style="text-transform: uppercase;">matrícula: </small><strong>{{tr.matricula}}</strong></p>
                </vs-td>
                <vs-td>
                    <h6>{{ tr.nombreProgramaActual  ? tr.nombreProgramaActual : ''}} </h6>
                </vs-td>
                <vs-td>
                    {{ tr.registros_academicos && Array.isArray(tr.registros_academicos) && tr.registros_academicos.length ? 'Alumno con registro académico' : 'Alumno sin registro académico' }}
                </vs-td>
                    
               
            </vs-tr>
        </template>
        <template #notFound>
            No hay registros
        </template>

        <template #footer class="m-2">
            <vs-pagination v-model="page" :length="pages" />           
        </template>
    </vs-table>
    <!-- <div class="custom-block tip"><p>Recuerda que solo se va asignar el bloque seleccionado a los alumnos que tengan registro academico.</p></div> -->
</div>
</template>

<script>
import bloques from '../../../../api/requests/asignar-bloques.js'
import academico from '../../../../api/requests/academico.js'

export default {
    props:[
        'value',
        'listNiveles',
        'listCiclos',
        'institucion',
        'cicloEscolar',
        'nivelAcademico',
        'grupo',
        'programa',
        'nombre',
        'bloque',
        'ejecutar'
    ],   
    data () {
        return {
            allCheck: false,
            selectedRow: [],
            tablaData: [],
            alumnos:[],
            oldIds:[],
            registroOld: [],
            oldDetail:{},
            page: 1, 
            max: 5,
            pages: 1,
            profesor: [],
            loadingGuardar: false 
        }
    },
    methods: {
        async openLoading(promise) {
          let loading 
          try {
            loading = this.$vs.loading({
                target: this.$refs.tabla_asignacion_bloques,
                color: 'dark'
            })
            const data = await promise
            loading.close()
            return data
          } catch (error) {
            if (loading){
                loading.close()
            }
            throw error
          }
          
        },
        async tablaCodigos () {
            try {
                const vm = this
                let params = {
                    page: this.page || 1,
                    size: this.max || 20
                }
                if (this.cicloEscolar) {
                    params.ciclo_escolar_id = this.cicloEscolar 
                }
                if (this.nivelAcademico) {
                    params.nivel_academico_id = this.nivelAcademico 
                }
                if (this.programa) {
                    params.programa_id = this.programa 
                }
                if (this.nombre) {
                    params.nombre = this.nombre 
                }
                if (this.grupo) {
                    params.grupo_id = this.grupo 
                }
                if (this.bloque) {
                    params.bloque_id = this.bloque 
                }
                const { data: response = null } = await this.openLoading(bloques.listado(this.institucion, params)) || {}
                const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.tablaData = dataTable
                if (Array.isArray(this.tablaData) && this.tablaData.length && this.bloque){
                    const oldCheckRows = this.tablaData.filter( e => {
                        const { registros_academicos: RegAcs = [] } = e || {}
                        const [ RegAc = {} ] = RegAcs
                        const { registros_academicos_crns: RegAcsCrn = [] } = RegAc
                        if (!vm.oldIds.includes(e.id) && RegAcsCrn.length){
                            vm.registroOld.push(e.registros_academicos[0].id)
                            vm.oldIds.push(e.id)
                            vm.oldDetail[e.id] = e
                            return Boolean(RegAcsCrn.length)
                        } else {
                            return false
                        } 
                    })
                    if (oldCheckRows.length) {
                        this.selectedRow = this.selectedRow.concat(oldCheckRows)
                    }
                    // this.oldIds = this.selectedRow.map(e => e.id)
                }
            } catch (error) {
                this.tablaData = []
                this.pages = 1

                 if (error.response.data && error.response.data.errors){
                    const data = error.response.data.errors
                    data.forEach(element => {
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element
                        })
                    });

                }else{
                    this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                    })
                }
            }
        },
        checkRegistroAcademico (row) {
            return Boolean(row instanceof Object && Array.isArray(row.registros_academicos) && row.registros_academicos.length)
        },
        newSearch () {
            const errors = this.sanityForm ()
            if (!errors.length) {
                this.page = 1
                this.selectedRow = []
                this.oldIds = []
                this.registroOld = []
                this.oldDetail = {} 
                this.tablaCodigos()
                this.profesores()
            } 
            this.$emit('errorFields', errors)
        },
        async actualizarRegistrosBloque () {
            try {
                if (this.bloque){
                    const vm = this
                    const nuevos = this.selectedRow.map(e=>e.registros_academicos[0].id)
                    const eliminados = vm.registroOld.filter(e=>!nuevos.includes(e))
                    if (vm.registroOld.length || vm.selectedRow.length) {
                        vm.loadingGuardar = true
                        try {
                            await bloques.create({ bloque_id: this.bloque, registros_academicos: nuevos, registros_academicos_a_desvincular: eliminados})
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Éxito',
                                text: `Registros guardados`
                            })
                            vm.loadingGuardar = false
                        } catch (error) {
                            if (error.response.data && error.response.data.errors){
                                const data = error.response.data.errors
                                data.forEach(element => {
                                    this.$vs.notification({
                                        progress: 'auto',
                                        color: 'danger',
                                        position: null,
                                        title: 'Error',
                                        text: element
                                    })
                                });
                                vm.loadingGuardar = false
                            }else{
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: `Algo salió mal`
                                })
                                vm.loadingGuardar = false
                            }
                        }
                    }
                    else{
                        this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: `No ha seleccionado ningun alumno`
                        })
                    }

                    
                    this.newSearch()
                }else{
                   this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: `Algo salió mal`
                    }) 
                }
            } catch (error) {
                console.error(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salió mal',
                    text: `Favor de comunicarse con el administrador.`
                }) 
            }
        },
        checkAllOnThisPage (val) {
            if (val && val.target && val.target.checked){
                this.selectedRow = [...this.selectedRow, ...this.tablaData]
            } else {
                const tableDataIds = this.tablaData.filter(e => this.checkRegistroAcademico(e)).map(e=>e.id)
                this.selectedRow = this.selectedRow.filter(e => !tableDataIds.includes(e.id))
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            let errorFields = []
            if (!this.checkByType ('number', this.cicloEscolar)) {
                errorFields.push('cicloEscolar')
            }
            if (!this.checkByType ('number', this.institucion)) {
                errorFields.push('institucion')
            }
            if (!this.checkByType ('number', this.bloque)) {
                errorFields.push('bloque')
            }
            return errorFields
        },
        async profesores () {
            try {
                let params = {
                    bloque_id: this.bloque
                }
                const { data: response} = await academico.profesoresGA(params)
                this.profesor = response
            } catch (error) {
                this.tablaData = []
                this.pages = 1
            }
        },
    },
    computed:{
        tableDataWithRegAc () {
            if (Array.isArray(this.tablaData) && this.tablaData.length){
                return this.tablaData.filter(e => this.checkRegistroAcademico(e))
            } else {
                return []
            }
        },
        selectedInThePage () {
            if (Array.isArray(this.tablaData) && this.tablaData.length){
                const tableDataIds = this.tablaData.filter(e => this.checkRegistroAcademico(e)).map(e=>e.id)
                return this.selectedRow.filter(e => tableDataIds.includes(e.id))
            } else {
                return []
            }
        }
    },
    watch:{
        page () {
            this.tablaCodigos()
        },
        selectedRow (val) {
            if (val){
                this.$emit('input', val);
            }
        },
        ejecutar () {
            this.newSearch()
        },
    }
}
</script>

<style>
.alumno .vs-table-content .vs-table__footer{
    margin: 2% !important;
}
</style> 